export const login =
{
    id: 1,
    email: "vardhan.b@gmail.com",
    token: "hgdhfgehgfbjbjkJBJYYGGYGTUgughgfdjhfuwefhew",
    firstName: "Test",
    lastName: "Test"
}


